import { Fragment, useEffect, useState, useRef } from "react";
import { withRouter } from "react-router";
import { Link, NavLink } from "react-router-dom";
import {
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  Navbar,
  NavbarBrand,
  ButtonGroup,
} from "reactstrap";
import { SITE_NAME } from "../../config/Config";
import UserProfile from "./UserProfile";
import "./header.css";
import { connect } from "react-redux";
import HeaderSearch from "../home/HeaderSearch";

const logo = "./../../assets/images/logo.svg";

const Header = (props) => {
  const [collapse, setCollapse] = useState(false);
  const [wideEnough, setWideEnough] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const menuRef = useRef(null);
  const togglerRef = useRef(null);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 992) {
        setWideEnough(false);
      } else {
        setWideEnough(true);
      }
    }

    function handleScroll() {
      let scrollTop = window.scrollY;
      if (!scrolled && scrollTop > 500) {
        setScrolled(true);
      }

      if (scrolled && scrollTop <= 500) {
        setScrolled(false);
      }
    }

    const handleClickOutside = (event) => {
      if (
        !wideEnough &&
        collapse &&
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        togglerRef.current &&
        !togglerRef.current.contains(event.target)
      ) {
        setCollapse(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);
    document.addEventListener("mouseup", handleClickOutside);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("mouseup", handleClickOutside);
    };
  }, [collapse, wideEnough]);

  const closeMenu = () => {
    if (!wideEnough) {
      setCollapse(false);
    }
  };

  const toggleMenu = () => {
    setCollapse((prev) => !prev);
  };

  return (
    <header className={"page-header m-header1"}>
      <Navbar
        color={
          wideEnough || collapse
            ? "m-grid__item m-header rtl fixed-top"
            : "m-grid__item m-header rtl"
        }
        expand="lg"
        // style={{width: document.documentElement.clientWidth }}
        className={
          props.location.pathname !== "/" || scrolled
            ? "top-nav-collapse"
            : "top-nav-collapse"
        }
      >
        <NavbarBrand href="/" className="page-logo">
          <img src={logo} alt={SITE_NAME} />
        </NavbarBrand>

        {!wideEnough && (
          <div ref={togglerRef}>
            <NavbarToggler
              onClick={toggleMenu}
              className={!collapse ? "collapsed" : ""}
            >
              <span />
            </NavbarToggler>
          </div>
        )}

        <Collapse
          innerRef={menuRef}
          isOpen={collapse}
          navbar
          className="d-flex1 justify-content-between1"
        >
          <div className="m-header-menu m-aside-header-menu-mobile text-center">
            <Nav className="m-menu__nav text-left">
              <NavItem>
                <NavLink
                  className="nav-link m-menu__item"
                  to="/"
                  exact
                  activeClassName="active"
                  onClick={closeMenu}
                >
                  خانه
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className="nav-link m-menu__item"
                  to="/brands"
                  exact
                  activeClassName="active"
                  onClick={closeMenu}
                >
                  بازارها/برندها
                </NavLink>
                {/*<NavLink className="nav-link m-menu__item" to="/complains" exact activeClassName="active">شکایت ها</NavLink>*/}
              </NavItem>
              <NavItem>
                <NavLink
                  className="nav-link m-menu__item"
                  to="/blogs"
                  exact
                  activeClassName="active"
                  onClick={closeMenu}
                >
                  وبلاگ
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className="nav-link m-menu__item"
                  to="/about"
                  exact
                  activeClassName="active"
                  onClick={closeMenu}
                >
                  درباره ما
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className="nav-link m-menu__item"
                  to="/register-brands"
                  exact
                  activeClassName="active"
                  onClick={closeMenu}
                >
                  ثبت نام برندها{" "}
                </NavLink>
              </NavItem>
              {!wideEnough && !props.user.isAuthenticated && (
                <Fragment>
                  <NavItem>
                    <NavLink
                      exact
                      activeClassName="active"
                      onClick={closeMenu}
                      className="nav-link m-menu__item login-menu"
                      to="/login"
                    >
                      ورود / عضویت
                    </NavLink>
                  </NavItem>
                </Fragment>
              )}
              <NavItem>
                <Link
                  className="nav-link m-menu__item medium gold"
                  onClick={closeMenu}
                  target="_blank"
                  to={{
                    pathname:
                      "https://docs.google.com/forms/d/e/1FAIpQLSdyPncipM9um-tPu2CwBHHcdf4b_eeo5zCF7BIV3325dPN4UQ/viewform",
                  }}
                >
                  نظر سنجی
                </Link>
              </NavItem>
            </Nav>
            {!wideEnough && (
              <Fragment>
                {props.user.isAuthenticated && <UserProfile />}
                <ButtonGroup className="m-auto pt-3 position-sticky bottom-1">
                  <Link
                    to="/add-complaint"
                    className="btn btn-sm btn-blue width-100"
                    onClick={closeMenu}
                  >
                    شکایت
                  </Link>
                  <Link
                    to="/add-review"
                    className="btn btn-sm btn-light-blue width-100"
                    onClick={closeMenu}
                  >
                    نظر
                  </Link>
                </ButtonGroup>
              </Fragment>
            )}
          </div>
        </Collapse>

        <div className="d-none d-lg-block">
          <div className="d-flex flex-row align-items-center top-link">
            <HeaderSearch className="mr-3 d-none d-xl-block" />
            <div className="mr-3">
              <Link
                to="/add-complaint"
                className="btn btn-outline-blue h-35 mr-1"
              >
                ثبت شکایت
              </Link>
              <Link
                to="/add-review"
                className="btn btn-outline-light-blue h-35"
              >
                ثبت نظر
              </Link>
            </div>

            <div>
              {props.user.isAuthenticated ? (
                <UserProfile />
              ) : (
                <Fragment>
                  <Link
                    to="/login"
                    title="ورود کاربر"
                    className="btn btn-blue h-35 mr-1"
                  >
                    ورود / عضویت
                  </Link>
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </Navbar>
    </header>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
export default connect(mapStateToProps, null)(withRouter(Header));
